import { Provider } from '@angular/core';
import { FileDataHttpService } from './abstract';
import { FileDataHttpServiceImpl } from './file-data-http.service';

export const FileDataHttpProvider: Provider = {
	provide: FileDataHttpService,
	useClass: FileDataHttpServiceImpl,
};
